import { CSSObject } from '@emotion/react';
import { theme } from '@frontend/theme';

export const radioFieldStyles: CSSObject = {
  display: 'flex',
  '.hide-radio': {
    marginBottom: 0,
    '&:last-of-type': {
      label: {
        marginRight: 0,
      },
    },
    '& > div': {
      display: 'none',
    },
    label: {
      cursor: 'pointer',
      marginLeft: 0,
      marginRight: theme.spacing(1),
      padding: theme.spacing(1),
    },
  },
};

export const getRadioOptionStyles = (isSelected: boolean): CSSObject =>
  isSelected
    ? {
        label: {
          borderRadius: theme.borderRadius.small,
          background: theme.colors.neutral10,
        },
      }
    : {
        label: {
          borderRadius: theme.borderRadius.small,
          border: `1px solid ${theme.colors.neutral50}`,
        },
      };
